import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  GetMovimentOrderCompleteRequest,
  GetMovimentOrderRequest,
  GetMovimentTomasRequest,
  GetPrintRemessaRequest,
} from './movement.component.model';
import {
  MovtoOPMessageTomas,
  ProductMovToOpMsgTomass,
} from './movement.model';
import { environment } from '../../environments/environment';
import { ProductionOrderService } from './production-order.service';

import { prod as coreEnvironment, TokenService as CoreTokenService } from '@totvsmoda/core';
import { TokenService as TokenService } from './token.service';


@Injectable({
  providedIn: 'root',
})
export class MovementService {
  constructor(
    private http: HttpClient,
    private coreTokenService: CoreTokenService,
    private tokenService: TokenService
  ) { }

  sendApiGetMovimentOrder(content: GetMovimentOrderRequest): Observable<any> {
    return this.http.get(environment.API_URL +
      'internal/production/v2/order/location?' +
      'BranchCode=' +
      content.branchCode +
      '&' +
      'cycleCode=' +
      content.cicleCode +
      '&' +
      'orderCode=' +
      content.orderCode +
      '&' +
      'ReferenceId=' +
      content.referenceId +
      '&' +
      'placeCode=' +
      content.placeCode +
      '&' +
      'ProgrammingSequence=' +
      content.programSequence
    );
  }

  sendApiGetMovimentOrderComplete(
    content: GetMovimentOrderCompleteRequest
  ): Observable<any> {
    return this.http.get(environment.API_URL +
      'internal/production/v2/order/location?' +
      'BranchCode=' +
      content.branchCode +
      '&' +
      'cycleCode=' +
      content.cicleCode +
      '&' +
      'orderCode=' +
      content.orderCode +
      '&' +
      'placeCode=' +
      content.placeCode
    );
  }

  public generateContentValidatorOrder(
    branchCode: number,
    cicleCode: number,
    orderCode: number,
    referenceId: string,
    placeCode: number,
    programSequence: number
  ): GetMovimentOrderRequest {
    var content = new GetMovimentOrderRequest();
    content.branchCode = branchCode;
    content.cicleCode = cicleCode;
    content.orderCode = orderCode;
    content.referenceId = referenceId;
    content.placeCode = placeCode;
    content.programSequence = programSequence;
    return content;
  }

  public generateContentValidatorOrderComplete(
    branchCode: number,
    cicleCode: number,
    orderCode: number,
    placeCode: number
  ): GetMovimentOrderCompleteRequest {
    var content = new GetMovimentOrderCompleteRequest();
    content.branchCode = branchCode;
    content.cicleCode = cicleCode;
    content.orderCode = orderCode;
    content.placeCode = placeCode;
    return content;
  }

  generateMessageContentToTomas(countSelected: any, componentName: string): MovtoOPMessageTomas {
    const content = new MovtoOPMessageTomas();
    console.log(countSelected)
    content.CD_COMPONENTE = componentName;
    content.DS_LSTMOVIMENTO.push(
      ...countSelected.items.map((product: any) => {
        return new ProductMovToOpMsgTomass(
          product.productionOrderBranchCode,
          product.productionOrderCycleCode,
          product.productionOrderCode,
          countSelected.originLocation,
          countSelected.destinationLocation,
          product.productCode,
          product.quantity
        );
      })
    );

    return content;
  }

  public generateContentMovementTomas(
    branchCode: number,
    content: string,
  ): GetMovimentTomasRequest {
    var query = new GetMovimentTomasRequest();
    query.branchCode = branchCode;
    query.content = content;
    return query;
  }

  public generateContentPrintRemessa(
    branchCode: number,
    shipmentCode: number
  ): GetPrintRemessaRequest {
    var query = new GetPrintRemessaRequest();
    query.branchCode = branchCode;
    query.shipmentCode = shipmentCode;
    return query;
  }

  sendApiMovementTomas(
    content: GetMovimentTomasRequest
  ): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.tokenService.getComponentCodeToken()}`
    });
    const httpOptions = {
      headers: headers
    };
    return this.http.post(environment.API_URL +
      'internal/production/v2/order/movement/tomas',
      content,
      httpOptions
    );
  }

  sendApiPrintRemessa(
    content: GetPrintRemessaRequest
  ): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.coreTokenService.token}`
    });

    const httpOptions = {
      headers: headers
    };

    return this.http.get(environment.API_URL +
      'internal/production-order/v2/shipments/print?' +
      'BranchCode=' + content.branchCode + '&' +
      'ShipmentCode=' + content.shipmentCode + '&' +
      'WithMaterial=' + 'true' + '&' +
      'WithService=' + 'true' + '&' +
      'WithValueService=' + true + '&' +
      'WithFooterSignature=' + true + '&' +
      'WithGridAnotation=' + true + '&' +
      'WithAddressSupplier=' + true
    );
  }
}

